import { render, staticRenderFns } from "./LiveVideo.vue?vue&type=template&id=31dce014"
import script from "./LiveVideo.vue?vue&type=script&lang=js"
export * from "./LiveVideo.vue?vue&type=script&lang=js"
import style0 from "./LiveVideo.vue?vue&type=style&index=0&id=31dce014&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports